import appGlobalConfig from "@shared/config/app/appGlobal.config";

const getDataStorage = () => {
    const localStorageData = localStorage.getItem(appGlobalConfig.CONFIG_MODULE.LOCALSTORAGE_KEY);
    return JSON.parse(localStorageData);
};

export default getDataStorage;